// * GET =====================================
export const NOM_GET_GET_VALUES_AUTO_COMPLETE = `/nom/get_values_auto_complete`;

export const NOM_GET_NOMENCLATURE = `/nom/nomenclature`;

export const NOM_GET_WORKFLOWS = `/nom/workflows`;

export const NOM_GET_MATTERMOST_CHANNELS = `/nom/mattermost_channels`;

export const NOM_GET_MATTERMOST_SERVERS = `/nom/mattermost_servers`;

/**
 * Selectable LLM models. The backend filters out inactive models and any past
 * the vendor's announced retirement date, so the list is never a superset of
 * what can actually be called.
 */
export const NOM_GET_LLM_MODELS = `/nom/llm_models`;

/**
 * Selectable prompt templates for a role (default 'autostory'). Replaces
 * /user/prompts, which returned raw unfiltered nomenclature rows.
 */
export const NOM_GET_LLM_PROMPT_TEMPLATES = `/nom/llm_prompt_templates`;

export const NOM_GET_NOMENCLATURE_AUTOCOMPLETE = `/nom/nomenclature_autocomplete`;

export const NOM_GET_NOMENCLATURE_BY_ID = `/nom/nomenclature_by_id`;

export const NOM_GET_LOCATION = `/nom/location`;

export const NOM_GET_GET_PANE_INFO = `/nom/get_pane_info`;

// * PATCH ===================================

// * POST ====================================]

export const NOMENCLATURE_POST_LIST_NOMENCLATURES = `/nomenclature/list_nomenclatures`;

/**
 * List nomenclatures for a given nomenclatureName and languageId.
 * Returns data formatted for ag‑Grid (rows and lastRow).
 */
export const NOMENCLATURE_POST_LIST_ITEMS = `/nomenclature/list_items`;

export const NOMENCLATURE_POST_GET_ITEM = `/nomenclature/get_item`;

export const NOMENCLATURE_POST_CREATE_ITEM = `/nomenclature/create_item`;

export const NOMENCLATURE_POST_UPDATE_ITEM = `/nomenclature/update_item`;

// * DELETE ==================================
export const NOMENCLATURE_DELETE_DELETE_ITEM = `/nomenclature/delete_item`;

export const NOMENCLATURE_DELETE_DELETE_ITEM_LANGUAGE = `/nomenclature/delete_item_language`;

// * PUT =====================================
